'use memo';

import { Outlet, createFileRoute, notFound } from '@tanstack/react-router';
import { featureFlags } from '@/lib/env';

/**
 * PO Ledger（PO台帳）一覧画面のレイアウト。
 *
 * FE-1 で配線した PO_LEDGER feature flag が無効な環境では 404 にする。
 * 値の出し分け（prd は非表示 / stg・demo・dev・local は表示）は backend の
 * feature-flag-definitions.ts が単一の正であり、FE は /v2/session が返す値を参照するだけ。
 *
 * 画面本体（ヘッダー・タブ・テーブル等）は FE-2 で実装する。
 */
export const Route = createFileRoute('/_staff/po-ledger/_list')({
  beforeLoad: () => {
    if (!featureFlags.check('PO_LEDGER')) {
      throw notFound();
    }
  },
  component: Layout
});
function Layout() {
  return <div className="flex flex-col">
      <Outlet />
    </div>;
}